<template>
  <ValidationObserver ref="form" v-slot="{ handleSubmit }">
    <form class="form" @submit.prevent="handleSubmit(handleCreateBot)"
          style="display: flex; flex-direction: column; gap: 20px">
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 25px">
        <div style="display: flex; flex-direction: column;">
          <label>Tên BOT <span style="color: red">*</span></label>
          <ValidationProvider name="Tên BOT" rules="required|max:50" v-slot="{ errors }" vid="nameBot">
            <el-input type="text" v-model="botName" placeholder="Nhập tên BOT"/>
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>
        </div>
        <div style="display: flex; flex-direction: column;">
          <label>Bot User Name <span style="color: red">*</span></label>
          <ValidationProvider name="Bot User Name" rules="required|max:50" v-slot="{ errors }" vid="userName">
            <el-input type="text" v-model="userName" placeholder="Nhập Bot User Name"/>
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>
        </div>
      </div>
      <div style="display: flex; flex-direction: column;">
        <label>Bot Api Key <span style="color: red">*</span></label>
        <ValidationProvider name="Bot Api Key" rules="required|max:255" v-slot="{ errors }" vid="apiKey">
          <el-input type="text" v-model="apiKey" placeholder="Nhập Bot Api Key"/>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
          </div>
        </ValidationProvider>
      </div>
      <div style="display: flex; flex-direction: column">
        <label>Mô tả</label>
        <ValidationProvider name="Mô tả" rules="max:200" v-slot="{ errors }" vid="description">
          <el-input type="text" v-model="description" placeholder="Nhập mô tả"/>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
          </div>
        </ValidationProvider>
      </div>
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 25px">
        <div>
          <label>Phân quyền xem <span style="color: red">*</span></label>
          <ValidationProvider name="Loại tài khoản" rules="required" v-slot="{ errors }" vid="role">
            <el-select v-model="roles" clearable multiple placeholder="Chọn loại tài khoản" style="width: 100%">
              <el-option
                  v-for="item in rolesOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>
        </div>
        <div>
          <label>Phòng ban</label>
          <el-select v-model="department" clearable multiple placeholder="Chọn phòng ban" style="width: 100%">
            <el-option
                v-for="item in listDepartment"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div style="display: flex;justify-content: flex-end; gap: 10px">
        <el-button @click="closeDialog"
                   style="background: #E6E6E6 !important; color: #0a0a0a !important;">
          Hủy bỏ
        </el-button>
        <button v-loading="loading" type="submit"
                style="background: #4D44B5 !important; color: white !important; padding: 10px 20px; border-radius: 5px">
          Xác nhận
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>

import {GET_DEPARTMENT} from "@/core/services/store/ticket-category/category.module";
import {CREATE_BOT, GET_LIST_ACCOUNT_TYPE} from "@/core/services/store/user/account-type.module";

export default {
  name: 'DialogCreateBot',
  data() {
    return {
      botName: null,
      userName: null,
      apiKey: null,
      description: null,
      roles: [],
      department: [],
      rolesOption: [],
      listDepartment: [],
      loading: false,
    }
  },
  mounted() {
    this.getListDepartment();
    this.getListAccountType();
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
      this.resetForm();
    },
    resetForm() {
      this.botName = null
      this.userName = null
      this.apiKey = null
      this.description = null
      this.roles = []
      this.department = []
    },
    getListAccountType() {
      this.$store.dispatch(GET_LIST_ACCOUNT_TYPE).then(res => {
        if (!res.error) {
          this.rolesOption = res.data ?? [];
        }
      })
    },
    handleCreateBot() {
      this.loading = true
      const payload = {
        name: this.botName,
        user_name: this.userName,
        api_key: this.apiKey,
        description: this.description,
        account_type_ids: this.roles,
        department_ids: this.department,
      }
      this.$store.dispatch(CREATE_BOT, payload).then(response => {
        this.$message.success('Thêm BOT thành công')
        this.loading = false
        this.resetForm();
        this.closeDialog();
        this.$emit('getListManagerBot')
      }).catch(e => {
        console.log(e, 'error')
      })
    },
    getListDepartment() {
      this.$store.dispatch(GET_DEPARTMENT).then((res) => {
        if (!res.error) {
          this.listDepartment = res.data ?? []
        }
      }).catch((e) => {
        console.log(e, 'error')
      });
    },
  }
}
</script>

<style lang="css" scoped>

</style>
